<template>
    <div class='choseSeat'>
        <div class='title'>
            <div class='name'>选座服务</div>
            <div>选 <span style='color:#FD5739'>{{cont}}/{{passengerLength}}</span> 个座</div>
        </div>

        <div class='content'>
            <template v-for='(item,index) in setClass' :key='index'>
                <div class='content_list' v-if='index < 2'>
                    <span class='seat' v-for='(data,dataIndex) in item' :key='dataIndex' @click.stop='submitSeat(index,dataIndex)' :class='{seataction:data.check,seatTrue:!data.type && !data.check}'>{{data.type?data.type:data.name}}</span>
                </div>
            </template>
        </div>

        <div class='footer'>
           * 若剩余席位无法满足选座需求,系统将自动为您分配席位。
        </div>


    </div>
</template>
<script>
import { onUpdated, reactive, toRefs,ref,computed  } from 'vue'
import { message } from 'ant-design-vue'
export default {
    componentname: "choseSeat",
    name: 'home',
    props:{
        passengersList : {
            type : Object,
            default:function(){
                return []
            }
        },
        seatType : {
            type : Object,
            default:function(){
                return {
                    seatType : 3
                }
            }
        }
    },
    setup(props,{ emit }){


        let setClass = ref([]);
        let cont = ref(0);
        

        const passengerLength = computed(()=>{
            let passengersLength = 0;
            props.passengersList.forEach(ele => {
                if(ele.checked){
                     passengersLength++;
                    if(ele.children.length){
                        passengersLength += ele.children.length;
                    }
                }
               
            })
            return passengersLength;
        })

        const setSeatlist = () => {
 
            if(props.seatType.seatType == 3){
                    //一等座
                    setClass.value.push([ 
                        {
                            type : '窗'
                        },
                        {
                            name :'A',
                            check : false
                        },
                        {
                            name :'C',
                            check : false
                        },
                        {
                            type : '过道'
                        },
                        {
                            name :'D',
                            check : false
                        },
                        {
                            name :'F',
                            check : false
                        },
                        {
                            type : '窗'
                        },]);
                }else if(props.seatType.seatType == 4){
                    //二等座
                    setClass.value.push( [{
                            type : '窗'
                        },
                        {
                            name :'A',
                            check : false
                        },
                        {
                            name :'B',
                            check : false
                        },
                        {
                            name :'C',
                            check : false
                        },
                        {
                            type : '过道'
                        },
                        {
                            name :'D',
                            check : false
                        },
                        {
                            name :'F',
                            check : false
                        },
                        {
                            type : '窗'
                        },]);
                }else if(props.seatType.seatType == 11){
                    //商务座
                    setClass.value.push( [
                        {
                            type : '窗'
                        },
                        {
                            name :'A',
                            check : false
                        },
                        {
                            name :'C',
                            check : false
                        },
                        {
                            type : '过道'
                        },
                        {
                            name :'F',
                            check : false
                        },
                        {
                            type : '窗'
                        },
                    ]);
                }
        }

        const init = () => {
     
            cont.value = 0;
            setClass.value = [];
            props.passengersList.forEach(element => {
                
                if(element.checked){
           
                    element.children.forEach(ele=>{
                        
                        setSeatlist()
                    })
                    
                    setSeatlist() 
                }
                    
            }); 
          
           
        }
        init();
    
        const submitSeat = (index,dataIndex) => {
            
            if(setClass.value[index][dataIndex].type){
                return;
            }
            if(!setClass.value[index][dataIndex].check){
                if(cont.value >= passengerLength.value){
                    message.error('您最多选择' + passengerLength.value + '个座位')
                    return
                }
                cont.value++;
            }else{
                cont.value--;
            }
             

            setClass.value[index][dataIndex].check = !setClass.value[index][dataIndex].check;
            emit('changeSeat',setClass.value);
        }

        return {
            passengerLength,
            init,
            cont,
            submitSeat,
            setClass,
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .choseSeat{
        // padding: 15px;
        margin-top: 35px;
        display: flex;
        flex-direction:column;

        align-items: center;
    }
    .title{
        display: flex;
        justify-content: space-between;
        font-size:14px ;
        border-bottom:1px solid #ededef ;
        padding-bottom: 8px;
        width: 100%;
        .name{
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
        }
    }
    .footer{
        margin-top: 35px;
        font-size:12px ;
        color:#B9B9B9;
        font-family: PingFangSC-Light, PingFang SC;
        width: 100%;
    }
    .content{
        margin-top:30px;
        width: 80%;
        .content_list{
            display: flex;
            justify-content: space-between;
            color:#B9B9B9;
            margin:16px 0;
            align-items: center;
            height: 40px;

        }
    }
    .seatTrue{
        line-height: 25px!important;
        background: url('../../assets/img/seat.png') no-repeat center center;
        background-size:100% ;
        cursor: pointer;
    }
    .seat{

        border-radius: 3px;
        display: block;
        width: 46px;
        height: 46px;
        line-height: 20px;
        text-align: center;
        padding: 4px;
        line-height:46px;
        font-family: PingFangSC-Light, PingFang SC;
        font-size:18px;
        
    }
    .seataction{
       line-height: 25px!important;
       background: url('../../assets/img/seatChose.png') no-repeat center center;
       background-size:100%;
       color:#f8523a;
    }

</style>

